import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const getTaskList = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/taskSchemeList`, params)
  return response.data
}

export const startTask = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/startTask`, params)
  return response.data
}

export const pauseTask = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/pauseTask`, params)
  return response.data
}

export const continueTask = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/continueTask`, params)
  return response.data
}

export const finishTask = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/finishTask`, params)
  return response.data
}

export const updateTask = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/updateTaskScheme`, params)
  return response.data
}

export const deleteTask = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/deleteTaskScheme`, params)
  return response.data
}

export const updateCallSpeed = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/names/updateTaskQueueV2`, params)
  return response.data
}
